import { render, staticRenderFns } from "./MaintenancePoint.vue?vue&type=template&id=e97f7b1e"
import script from "./MaintenancePoint.vue?vue&type=script&lang=js"
export * from "./MaintenancePoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports